import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaymentBookPage } from './payment-book.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentBookPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentBookPageRoutingModule {}
